import http from '@/utils/http'

export function getOrders(params){
    return http.get('/orders',{params})
}
export function getOrderDetail(id){
    return http.get(`/orders/${id}`)
}
export function putOrder(id,data){
    return http.put(`/orders/${id}`,data)
}

export function getPromotionCodes(params){
    return http.get('/promotion_codes',{params})
}
export function getPromotionCodesDetail(id){
    return http.get(`/promotion_codes/${id}`)
}
export function putPromotionCodes(id,data){
    return http.put(`/promotion_codes/${id}`,data)
}
export function addPromotionCodes(data){
    return http.post('/promotion_codes',data)
}
export function orderPriceRequest(id,data){
    return http.post(`/order/${id}/price_request`,data)
}
